<template>
  <v-row class="flex-column mt-6 pr-8">
    <router-view />
    <!-- Intentionally added this condition to follow child routes -->
    <v-col v-if="$route.name === 'Tiers'">
      <v-row no-gutters>
        <v-col md="2"><h2 class="title-1 ml-5 primary-text">Tiers</h2></v-col>
        <v-col class="text-right">
          <v-btn icon @click="resetAll" class="mr-1">
            <v-icon>restart_alt</v-icon>
          </v-btn>
          <v-text-field
            v-model="search"
            class="custom-search"
            label="Search"
            solo
            append-icon="search"
            hide-details
            single-line
            @keyup="getTiersListData(), pageReset()"
          />
          <v-select
            v-model="selectedTierType"
            class="custom-select"
            :item-text="(item) => item.products"
            :items="productsFilter"
            :item-value="(item) => item.products"
            label="Products"
            append-icon="expand_more"
            multiple
            solo
            attach
            @change="getTiersListData"
          />
          <v-btn
            class="primary_btn small"
            depressed
            @click="$router.push({ name: 'addTiers' })"
            >Add Tier</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
    <!-- Intentionally added this condition to follow child routes -->
    <v-col v-if="$route.name === 'Tiers'" class="custom-panel">
      <v-data-table
        id="tiersList"
        :headers="headers"
        :items="tiersList.data"
        :options.sync="options"
        :server-items-length="tiersList.total"
        :loading="loading"
        class="elevation-1"
        hide-default-footer
        :sort-desc.sync="sortDesc"
        :header-props="{ sortIcon: 'arrow_upward' }"
        @update:sort-desc="getTiersListData"
      >
        <template v-slot:item.tier_name="{ item }">
          <b> {{ item.tier_name }}</b>
        </template>
        <template v-slot:item.action="{ item }">
          <v-row>
            <v-col cols="6">
              <v-btn icon>
                <v-icon @click="$router.push(`/tiers/edit-tier/${item.id}`)"
                  >edit</v-icon
                >
              </v-btn>
              <!-- <edit-licence/> -->
            </v-col>
          </v-row>
        </template>
      </v-data-table>
      <div class="primary-icon">
        <license-pagination
          :total="tiersList.total"
          :value="page"
          @input="pageEmit"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LicensePagination from '@/components/LicensePagination/licensePagination.vue';
export default {
  components: {
    LicensePagination,
  },
  data: () => ({
    headers: [
      {
        text: 'Tier',
        align: 'start',
        sortable: true,
        value: 'tierName',
      },
      //{ text: 'Description', value: 'description' },
      { text: 'Products Included', value: 'Products' },
      { text: '# of Users in TED', value: 'noOfUsersTed' },
      { text: 'License cost per User in TED', value: 'licenseCostForTedusers' },

      { text: '# of Users in Pace', value: 'noOfUsersPace' },
      {
        text: 'License cost per User in Pace',
        value: 'licenseCostForPaceusers',
      },
      { text: '# of Users in Mobe', value: 'noOfUsersMobe' },
      {
        text: 'License cost per User in Mobe',
        value: 'licenseCostForMobeusers',
      },

      { text: 'Actions', value: 'action', sortable: false },
    ],
    search: '',
    options: {},
    loading: false,
    page: 1,
    itemsPerPage: 10,
    selectedTierType: null,
    productList: [],
    sortDesc: [],
  }),
  computed: {
    ...mapGetters({
      tiersList: 'tiers/getTier',
    }),
    // pageCount() {
    //   return Math.ceil(this.tiersList.total / this.itemsPerPage)

    //   },
    productsFilter() {
      return this.productList.map((product) => ({
        id: product.id,
        products: product.productName,
      }));
    },
  },
  // watch: {
  //   options: {
  //     handler() {
  //       if (this.options.page !== undefined) this.getTiersListData();
  //     },
  //     deep: true,
  //   },
  // },
  async mounted() {
    console.log("datagsssssh",this.tiersList);
    if (this.options.page !== undefined) this.getTiersListData();
    //  this.totalTiers = list.data.total;
    let res = await this.getProducts();
    this.productList = res.data;
  },
  methods: {
    ...mapActions({
      getTierList: 'tiers/getTierList',
      getProducts: 'tiers/getProductList',
    }),
    pageReset() {
      if (this.search) {
        this.page = 1;
      }
    },
    pageEmit(data) {
      if (data > 0) {
        this.page = data;
        this.getTiersListData();
      }
    },
    resetAll() {
      this.search = '';
      this.page = 1;
      this.selectedTierType = null;
      this.sortDesc = [];
      this.getTiersListData();
    },
    getTiersListData() {
      if (this.selectedTierType) {
        this.page = 1;
      }
      const { sortBy } = this.options;

      this.getTierList({
        page: this.page,
        limit: 10,
        search: this.search || '',
        products: this.selectedTierType ? this.selectedTierType.join(',') : '',
        sort: sortBy[0],
        desc: this.sortDesc[0] || 0,
      })
        .then((res) => {
          if (res.status === 200) {
            let items = res.data.data;
            console.log(items);
            this.loading = false;
          }
        })
        .catch((err) => {
          // Skip login until API and schema got finalise
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss">
.custom-tabs {
  .v-data-footer {
    .mdi-chevron-left,
    .mdi-chevron-right {
      border: solid black;

      border-width: 0 2px 2px 0;

      padding: 3px;

      width: 10px !important;

      height: 10px !important;

      opacity: 0.4;
    }

    .mdi-chevron-left {
      transform: rotate(135deg);
    }

    .mdi-chevron-right {
      transform: rotate(-45deg);
    }

    .v-btn--disabled {
      .mdi-chevron-left,
      .mdi-chevron-right {
        opacity: 0.1;
      }
    }
  }
  
}
.custom-select {
    .v-simple-checkbox {
      border: 0px !important;
    }
  }
</style>
